var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "15px",
    viewBox: "0 0 14 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B4E981BA-D9F5-49B4-9A39-3CC5EC5939F1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.81824193,8.33334128 C8.42072852,8.33334128 8.90914041,8.83080207 8.90914041,9.44445106 L8.90914041,13.8888902 C8.90914041,14.5025392 8.42072852,15 7.81824193,15 L6.36371062,15 C5.76122402,15 5.27281213,14.5025392 5.27281213,13.8888902 L5.27281213,9.44445106 C5.27281213,8.83080207 5.76122402,8.33334128 6.36371062,8.33334128 L7.81824193,8.33334128 Z M2.72738234,6.85186156 C3.32986893,6.85186156 3.81828082,7.34932236 3.81828082,7.96297135 L3.81828082,13.8888902 C3.81828082,14.5025392 3.32986893,15 2.72738234,15 L1.27285103,15 C0.670364431,15 0.181952544,14.5025392 0.181952544,13.8888902 L0.181952544,7.96297135 C0.181952544,7.34932236 0.670364431,6.85186156 1.27285103,6.85186156 L2.72738234,6.85186156 Z M12.9091015,5.37038184 C13.5115881,5.37038184 14,5.86784264 14,6.48149163 L14,13.8888902 C14,14.5025392 13.5115881,15 12.9091015,15 L11.4545702,15 C10.8520836,15 10.3636717,14.5025392 10.3636717,13.8888902 L10.3636717,6.48149163 C10.3636717,5.86784264 10.8520836,5.37038184 11.4545702,5.37038184 L12.9091015,5.37038184 Z M12.9046427,1.78738401e-05 C13.0457179,-0.00113097621 13.1871528,0.0531022954 13.2947924,0.162736135 C13.3480452,0.216975581 13.3879848,0.279640049 13.4146112,0.346517026 C13.4392815,0.405753455 13.4545508,0.478836339 13.4545508,0.555572971 L13.4545508,2.78724168 C13.4545508,3.09406618 13.2103448,3.34279657 12.9091015,3.34279657 C12.6078582,3.34279657 12.3636523,3.09406618 12.3636523,2.78724168 L12.3636523,1.89680093 L7.47666713,6.87432826 C7.31707915,7.03687296 7.07568784,7.08252434 6.86944835,6.98916411 L0.324057454,4.02620468 C0.0487778489,3.90159145 -0.0751989353,3.57327975 0.0471475556,3.29289999 C0.169494047,3.01252022 0.491833686,2.88624649 0.76711329,3.01085972 L6.97017755,5.81885515 L11.5828361,1.12073691 L10.7241654,1.12694906 C10.4229297,1.12912839 10.1769953,0.882170958 10.1748556,0.575354203 C10.172716,0.268537447 10.4151812,0.0180466306 10.7164169,0.0158673045 L12.9046427,1.78738401e-05 Z",
    id: "path-progress-icon"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AFBFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02C7D4",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\xCDndice-POC---GMSA",
    transform: "translate(-362.000000, -318.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wrapper"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.000000, 82.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Datos-de-Agencia-[Div]",
    transform: "translate(0.000000, 110.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Datos-[Col-8]",
    transform: "translate(0.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tiempos-(DER)",
    transform: "translate(305.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cajas-NO-Paletizadas",
    transform: "translate(1.000000, 72.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-progress-icon",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-progress-icon"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#2E2E2E",
    fillRule: "nonzero",
    xlinkHref: "#path-progress-icon"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8Color-Color/Gradient/Aqua",
    mask: "url(#mask-progress-icon)",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Gradient",
    x: 0,
    y: 0,
    width: 14,
    height: 15
  }))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressIcon);
export default __webpack_public_path__ + "static/media/progress-icon.18d26c6705f7bb78e94cde02568af90e.svg";
export { ForwardRef as ReactComponent };